/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Samples_Edit_Select_Carrier_PlaceholderInputs */

const en_samples_edit_select_carrier_placeholder = /** @type {(inputs: Samples_Edit_Select_Carrier_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select carrier`)
};

const es_samples_edit_select_carrier_placeholder = /** @type {(inputs: Samples_Edit_Select_Carrier_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar transportista`)
};

/**
* | output |
* | --- |
* | "Select carrier" |
*
* @param {Samples_Edit_Select_Carrier_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const samples_edit_select_carrier_placeholder = /** @type {((inputs?: Samples_Edit_Select_Carrier_PlaceholderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Samples_Edit_Select_Carrier_PlaceholderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_samples_edit_select_carrier_placeholder(inputs)
	return es_samples_edit_select_carrier_placeholder(inputs)
});